import React, { memo } from 'react';
import { Gift } from 'lucide-react';
const bonuses = [{
  title: 'YOGA READY™ Class Themes Vault',
  description: '50 themed class ideas ready to use so you never run out of inspiration again.'
}, {
  title: 'YOGA READY™ Cueing Scriptbook',
  description: 'The precise phrases to guide, correct and sound like an expert in every class.'
}, {
  title: 'YOGA READY™ Substitution Guide',
  description: 'Safe adaptations for common limitations, injuries and mixed-level groups.'
}, {
  title: 'YOGA READY™ Pre-Class Prep Kit',
  description: 'Your 10-minute professional ritual to arrive centered, calm and fully ready.'
}, {
  title: 'YOGA READY™ Student Experience Toolkit',
  description: 'Simple tools to make every class feel more premium and memorable.'
}];
export function BonusSection() {
  return <>
      <section className="py-8 px-4 bg-white border-y-4 border-brand-gold/30" data-id="element-14">
        <div className="max-w-4xl mx-auto" data-id="element-15">
          <div className="text-center mb-6" data-id="element-16">
            <h2 className="text-2xl sm:text-3xl font-serif font-extrabold text-brand-graphite mb-1 uppercase" data-id="element-17">
              5 LUXURY BONUSES INCLUDED
            </h2>
            <p className="text-base font-bold text-brand-rose mb-2" data-id="element-18">
              Plus, you'll receive 5 luxury bonuses
            </p>
            <p className="text-base text-brand-graphite/90 font-medium leading-snug" data-id="element-19">
              Exclusive resources that will transform your day-to-day — included
              FREE with your pack.
            </p>
          </div>

          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-3 mb-5" data-id="element-20">
            {bonuses.map((bonus, i) => <div key={i} className="bg-brand-cream border-2 border-brand-gold/50 p-4 rounded-lg text-center shadow-sm" data-id="element-21">
                <div className="w-10 h-10 mx-auto bg-brand-gold/20 rounded-full flex items-center justify-center mb-2" data-id="element-22">
                  <Gift className="w-5 h-5 text-brand-petrol" data-id="element-23" />
                </div>
                <p className="text-[11px] font-extrabold text-brand-gold mb-1 tracking-wider uppercase" data-id="element-24">
                  🎁 BONUS {i + 1} — FREE
                </p>
                <h3 className="text-sm font-bold text-brand-graphite mb-1.5 leading-tight" data-id="element-25">
                  {bonus.title}
                </h3>
                <p className="text-xs text-brand-graphite/80 font-medium leading-snug" data-id="element-26">
                  {bonus.description}
                </p>
              </div>)}
          </div>

          <p className="text-center font-extrabold text-brand-petrol text-base sm:text-lg uppercase tracking-wide bg-brand-petrol/10 py-2 rounded-md" data-id="element-27">
            The 5 bonuses are FREE with your purchase today.
          </p>
        </div>
      </section>

      <section className="py-8 px-4 bg-brand-cream" data-id="element-28">
        <div className="max-w-4xl mx-auto" data-id="element-29">
          <h2 className="text-2xl sm:text-3xl font-serif font-extrabold text-center text-brand-graphite mb-1 uppercase" data-id="element-30">
            WHAT IS GOING TO CHANGE
          </h2>
          <p className="text-base font-bold text-center text-brand-rose mb-1" data-id="element-31">
            What will change in your professional life
          </p>
          <p className="text-base text-center text-brand-graphite/90 mb-6 font-bold" data-id="element-32">
            Real benefits starting from the first week:
          </p>

          <div className="grid sm:grid-cols-2 gap-3" data-id="element-33">
            {[{
            emoji: '⚡',
            title: 'Mental Load Liberation',
            desc: 'Open the system, choose the sequence according to your class, and teach. Planning is done.'
          }, {
            emoji: '👑',
            title: 'Authority and Confidence',
            desc: "Arrive at the studio with an expert's posture and the right words to guide your students."
          }, {
            emoji: '🌿',
            title: 'True Student Progression',
            desc: 'Biomechanically sound sequences so your students notice results and keep coming back.'
          }, {
            emoji: '😌',
            title: 'Zero Transition Stress',
            desc: 'Master the art of fluid connections for a perfect flow that will impress your students.'
          }].map((item, i) => <div key={i} className="bg-white border-l-4 border-brand-petrol p-4 rounded-r-lg shadow-sm flex gap-3 items-start" data-id="element-34">
                <div className="text-2xl shrink-0 mt-0.5" data-id="element-35">{item.emoji}</div>
                <div data-id="element-36">
                  <h3 className="text-sm sm:text-base font-bold text-brand-graphite mb-0.5 uppercase tracking-wide" data-id="element-37">
                    {item.title}
                  </h3>
                  <p className="text-brand-graphite/80 text-xs sm:text-sm font-medium leading-snug" data-id="element-38">
                    {item.desc}
                  </p>
                </div>
              </div>)}
          </div>
        </div>
      </section>
    </>;
}